import React from 'react';
import { Card, Typography, Alert, Divider } from 'antd';
import CsvExcelImport from '../../../components/common/CsvExcelImport';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const VehicleFuelImport: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <Title level={3} style={{ marginTop: 0 }}>{t('machinery.fuel.import.title')}</Title>
      <Paragraph>
        {t('machinery.fuel.import.description')} <Text code>adm_vehicle_fuel_entries</Text> {t('machinery.fuel.import.descriptionSuffix')}
      </Paragraph>
      <Alert
        type="info"
        showIcon
        message={t('machinery.fuel.import.expectedColumns')}
        description={
          <div>
            <div><Text code>vehicle_id</Text> {t('machinery.fuel.import.required')}, <Text code>entry_date</Text> (YYYY-MM-DD), <Text code>liters</Text> {t('machinery.fuel.import.required')}</div>
            <div><Text code>source_type</Text> {t('machinery.fuel.import.required')}, <Text code>fuel_type</Text>, <Text code>source_pump_id</Text>, <Text code>source_vehicle_id</Text>, <Text code>source_name</Text></div>
            <div><Text code>odometer_reading</Text>, <Text code>hours_counter_reading</Text>, <Text code>location</Text>, <Text code>reference_no</Text>, <Text code>company</Text>, <Text code>note</Text></div>
          </div>
        }
        style={{ marginBottom: 16 }}
      />
      <Divider />
      <CsvExcelImport tableName="adm_vehicle_fuel_entries" />
    </Card>
  );
};

export default VehicleFuelImport;


